var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnfurnished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1311 9.15936L6.04858 20.0568H11.7257V34.0445H14.8447V22.8268H22.9366V34.0445H38.5364V20.0568H44.2142L25.1311 9.15936ZM30.5143 28.4996H25.215V22.9535H30.5143V28.4996ZM36.4124 28.4996H31.1125V22.9535H36.4124V28.4996Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8399 35.642H9.42411V37.2235H7.40356V37.8119H9.46146V37.5174H10.7105V37.8119H12.7678V37.5174H14.0169V37.8119H16.0735V37.5174H17.3232V37.8119H19.3799V37.5174H20.6289V37.8119H22.6862V37.5174H23.9353V37.8119H25.9932V37.5174H27.2416V37.8119H29.2995V37.5174H30.5479V37.8119H32.6052V37.5174H33.8549V37.8119H35.9116V37.5174H37.1612V37.8119H39.2179V37.5174H40.4664V37.8119H42.5249V37.2235H40.8399V35.642Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6862 5.84204H20.6289V6.43045H22.6862V5.84204Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0741 5.84204H14.0168V6.43045H16.0741V5.84204Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9932 5.84204H23.9353V6.43045H25.9932V5.84204Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84878 5.84204H0.791504V6.43045H2.84878V5.84204Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3803 5.84204H17.323V6.43045H19.3803V5.84204Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5242 5.84204H40.4663V6.43045H42.5242V5.84204Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4431 5.84204H50.3865V6.43045H52.4431V5.84204Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2993 5.84204H27.2415V6.43045H29.2993V5.84204Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2178 5.84204H37.1611V6.43045H39.2178V5.84204Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9116 5.84204H33.855V6.43045H35.9116V5.84204Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6045 5.84204H30.5479V6.43045H32.6045V5.84204Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46084 5.84204H7.40356V6.43045H9.46084V5.84204Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84878 37.2234H0.791504V37.8119H2.84878V37.2234Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4431 37.2234H50.3865V37.8119H52.4431V37.2234Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15469 37.2234H4.09741V37.8119H5.75487V39.6995H6.34266V37.6423H6.15469V37.2234Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 32.2928H48.6643V34.3501H49.2515V32.2928Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 28.9858H48.6643V31.0437H49.2515V28.9858Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6644 37.2235H47.0798V37.8119H49.1371V37.4757H49.2516V35.5984H48.6644V37.2235Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 22.3738H48.6643V24.4317H49.2515V22.3738Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 25.6801H48.6643V27.7373H49.2515V25.6801Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 12.454H48.6643V14.5119H49.2515V12.454Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 9.14838H48.6643V11.2057H49.2515V9.14838Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6644 7.89993H49.2516V5.84204H49.1371H48.6644H47.0798V6.43045H48.6644V7.89993Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2515 15.761H48.6643V17.8183H49.2515V15.761Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9405 8.71915H12.5277V6.43042H12.7677V5.84202H12.5277V1.50092H11.9405V5.84202H10.7104V6.43042H11.9405V8.71915Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2514 19.8897V19.0668H48.6642V19.8897H46.3755V20.4781H48.6642V21.1253H49.2514V20.4781H54.2776V19.8897H49.2514Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 10.5076H43.5234V12.5649H44.1106V10.5076Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 33.652H43.5234V35.7099H44.1106V33.652Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 27.0394H43.5234V29.0966H44.1106V27.0394Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 20.4266H43.5234V22.4839H44.1106V20.4266Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 23.7324H43.5234V25.7903H44.1106V23.7324Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 3.89496H43.5234V5.95224H43.7733V6.43043H45.8311V5.84203H44.1106V3.89496Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 30.345H43.5234V32.4029H44.1106V30.345Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 40.2642H43.5234V41.8843H44.1106V40.2642Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 7.20068H43.5234V9.25857H44.1106V7.20068Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 17.1204H43.5234V19.1783H44.1106V17.1204Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 36.9584H43.5234V39.0157H44.1106V37.8119H45.8311V37.2235H44.1106V36.9584Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 13.8134H43.5234V15.8712H44.1106V13.8134Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1106 0.588623H43.5234V2.64651H44.1106V0.588623Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 14.4973H5.75464V16.5552H6.34243V14.4973Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 1.27252H5.75464V3.33041H6.34243V1.27252Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 24.4169H5.75464V26.4748H6.34243V24.4169Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 11.1916H5.75464V13.2489H6.34243V11.1916Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 27.7233H5.75464V29.7806H6.34243V27.7233Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 31.029H5.75464V33.0869H6.34243V31.029Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 40.9486H5.75464V42.5687H6.34243V40.9486Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75487 6.6362H6.34266V4.57892H5.75487V5.84206H4.09741V6.43047H5.75487V6.6362Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 34.3359H5.75464V36.3938H6.34243V34.3359Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 7.88519H5.75464V9.94308H6.34243V7.88519Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 21.1106H5.75464V23.1679H6.34243V21.1106Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34243 17.8043H5.75464V19.8622H6.34243V17.8043Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8889 42.5075H14.5814V40.9541H13.9937V42.5075V43.0959V44.6499H14.5814V43.0959H22.8889V44.6499H23.4767V40.9541H22.8889V42.5075Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfurnished);
export default __webpack_public_path__ + "static/media/unfurnished.0ee21ade1a376ab16cf9e90e0ef5b2f2.svg";
export { ForwardRef as ReactComponent };